// class BlogFilter extends HTMLElement {
//   constructor() {
//     super();

//     const filter = document.querySelector("select");
//     filter.addEventListener("change", function () {
//       window.location.href = filter.value;
//     });
//   }
// }

// customElements.define("blog-filter", BlogFilter);

class BlogFilter extends HTMLElement {
  constructor() {
    super();
    const select_filter = document.querySelector(".no-dot-wrapper .no-dot");
    const filter_list = document.querySelector(".cstm-div-select__select ul.select_list");
    const list_items = filter_list.querySelectorAll("li");
    // Set saved filter text and selected <li> on page load
    const savedText = localStorage.getItem("selectedFilterText");
    if (savedText) {
      select_filter.textContent = savedText;
      list_items.forEach(li => li.textContent === savedText ? li.setAttribute("selected", "true") : li.removeAttribute("selected"));
    }
    // Toggle dropdown visibility
    document.querySelector(".no-dot-wrapper").addEventListener("click", () => {
      filter_list.style.display = filter_list.style.display === "block" ? "none" : "block";
    });
    // Handle li click
    list_items.forEach(li => {
      li.addEventListener("click", () => {
        select_filter.textContent = li.textContent;
        list_items.forEach(item => item.removeAttribute("selected"));
        li.setAttribute("selected", "true");
        localStorage.setItem("selectedFilterText", li.textContent);
        window.location.href = li.getAttribute("value");
        filter_list.style.display = "none";
      });
    });
    if (window.location.href == 'https://liquid-iv.co.in/blogs/all' || window.location.href == 'https://liquid-iv.co.in/blogs/all/') {
      select_filter.textContent = select_filter.getAttribute("blog-all-text");
    }
  }
}
customElements.define("blog-filter", BlogFilter);
